module.exports = __webpack_public_path__ + "img/cs.cc32e01b.png";